export default __webpack_public_path__ + "static/website@2x-5a773314107f055550efdcb867d591ae.jpg";